import { put } from 'redux-saga/effects';

import { showError } from 'ducks/app/actions';
import * as errorTypes from './errorTypes';

export default {
  *[errorTypes.CANNOT_GENERATE_REPORT]() {
    yield put(showError('stores:cannotGenerateReport'));
  },
};
